import React from 'react';
import { Link } from 'react-router-dom';
import { FaBookOpen, FaChalkboardTeacher, FaLaptop, FaGraduationCap, FaCalendarAlt, FaMapMarkerAlt, FaUserGraduate } from 'react-icons/fa';
import './Home.css';
import ClassImage from '../assets/Class.png';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Université des Sciences de Sébikotane</h1>
            <p>Excellence académique et innovation au service du développement</p>
            <div className="hero-buttons">
              <Link to="/admissions" className="btn primary">Postuler Maintenant</Link>
              <Link to="/about" className="btn secondary">Découvrir l'U2S</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="features">
        <div className="section-header">
          <h2>Nos Domaines d'Excellence</h2>
          <p>Formations innovantes adaptées aux défis contemporains</p>
        </div>
        
        <div className="feature-cards">
          <div className="feature-card">
            <div className="feature-icon"><FaBookOpen /></div>
            <h3>Études Islamiques</h3>
            <p>Études approfondies des sciences religieuses et de la pensée islamique</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon"><FaChalkboardTeacher /></div>
            <h3>Sciences de l'Éducation</h3>
            <p>Formation des enseignants et spécialistes des systèmes éducatifs</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon"><FaLaptop /></div>
            <h3>Formation en Ligne</h3>
            <p>Plateforme numérique pour un apprentissage flexible et accessible</p>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="programs">
        <div className="section-header">
          <h2>Nos Programmes Académiques</h2>
          <p>Formations diplômantes</p>
        </div>
        
        <div className="programs-container">
          <div className="program-card">
            <div className="program-header">
              <FaGraduationCap className="program-icon" />
              <h3>Licence en Études Islamiques</h3>
            </div>
            <div className="program-body">
              <ul>
                <li>Fiqh et Usul al-Fiqh</li>
                <li>Tafsir et Sciences du Coran</li>
                <li>Hadith et Sciences du Hadith</li>
                <li>Histoire et Civilisation Islamique</li>
              </ul>
              <div className="program-footer">
                <span>Durée: 3 ans</span>
                <Link to="/admissions" className="btn secondary">Découvrir</Link>
              </div>
            </div>
          </div>
          
          <div className="program-card">
            <div className="program-header">
              <FaGraduationCap className="program-icon" />
              <h3>Licence en Sciences de l'Éducation</h3>
            </div>
            <div className="program-body">
              <ul>
                <li>Pédagogie Générale</li>
                <li>Didactique des Disciplines</li>
                <li>Psychologie de l'Éducation</li>
                <li>Administration Scolaire</li>
              </ul>
              <div className="program-footer">
                <span>Durée: 3 ans</span>
                <Link to="/admissions" className="btn secondary">Découvrir</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;